<template>
  <div class="business-states"><ring-chart :segments="segments" :value="value" :caption="caption" :label="label" paused /><div class="business-state-list"><div v-for="item in segments" :key="item.name"><span><i :style="{ background: item.color }" />{{ item.name }}</span><b>{{ n(item.value) }}<small>{{ unit }}</small></b></div></div></div>
</template>
<script>
import RingChart from '../nandu-energy-screen/components/RingChart.vue'
import { num } from './model'
export default { components: { RingChart }, props: { segments: { type: Array, required: true }, value: { type: String, required: true }, caption: { type: String, default: '' }, label: { type: String, required: true }, unit: { type: String, default: '' } }, methods: { n: num } }
</script>
